import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getTeacherSliceContent = createAsyncThunk('/teachers/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getTeacher`, {});
    return response;
})

export const teacherSlice = createSlice({
    name: 'teachers',
    initialState: {
        isLoading: false,
        teachers : []
    },
    reducers: {
    },
    extraReducers: {
		[getTeacherSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getTeacherSliceContent.fulfilled]: (state, action) => {
			state.teachers = action.payload.data
			state.isLoading = false
		},
		[getTeacherSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default teacherSlice.reducer